import { Box, Typography } from '@mui/material';

import ChangelogTable from '@/designs-dev/inspect/ChangelogTable';
import { collectChangelog } from '@/designs-dev/inspect/ds-registry';

// The compiled design-system changelog: every component's changes in one
// date-sorted table, newest first, with a Component column saying where each
// one lives. This is the single place to read changes across the whole
// prototype — it replaces the per-component changelogs that used to crowd the
// inspect panel.
const GlobalChangelog = () => {
  const rows = collectChangelog();

  if (rows.length === 0) return null;

  return (
    <Box>
      <Typography sx={{ mb: 0.5 }} variant='h4'>
        Changelog
      </Typography>
      <Typography sx={{ mb: 1.5 }} variant='body2' color='text.secondary'>
        Every design-system change across the prototypes, newest first. The
        Component column says where each one lives.
      </Typography>
      <ChangelogTable rows={rows} />
    </Box>
  );
};

export default GlobalChangelog;
